import React from 'react'
import { Settings } from 'lucide-react'
import { useNavigate, useParams } from 'react-router-dom'
import IntegrationSelector from './IntegrationSelector'
import CustomFields from './CustomFields'

export default function CustomFieldsPage() {
  const navigate = useNavigate()
  const { integrationId } = useParams<{ integrationId: string }>()

  const handleIntegrationSelected = (selectedIntegrationId: string) => {
    navigate(`/integrations/${selectedIntegrationId}/custom-fields`)
  }

  if (!integrationId) {
    return (
      <IntegrationSelector
        title="Custom Fields"
        description="Custom fields are configured per integration."
        icon={<Settings className="h-6 w-6 text-blue-600" />}
        onIntegrationSelected={handleIntegrationSelected}
      />
    )
  }

  return (
    <div className="p-6">
      <CustomFields />
    </div>
  )
}